import {mapState} from "vuex";
import Sites from "../../services/Sites";
import Clients from "../../services/Clients";
import _ from "lodash";

export default {
    data() {
        return {
            showBlockedClient: false,
            isLoading: false,
            formValid: true,
            orderValid: true,
            showLiveLink: false,
            showItemDeleteConfirm: false,
            showOrderConfirm: false,
            showMailTemplate: false,
            isOverlay: false,
            isSpecialClient: false,
            isFixClient: false,
            isAgencyClient: false,
            ediTableContent: '',
            currentItem: null,
            deleteItem: null,
            isCheckedAdultPrice: false,
            showLinkInsertionPopup: false,
            isExists: false,
            isBillingTypeBoth: false,
            blockedClientInfo: null,
            headers: [
                {
                    text: '#ID',
                    value: 'cartId'
                },
                {
                    text: 'Site URL',
                    value: 'siteUrl'
                },
                {
                    text: 'Custom Entity Name',
                    value: 'customEntityName'
                },
                {
                    text: 'Live Link',
                    value: 'liveLink'
                },
                {
                    text: 'Link Insertions',
                    value: 'linkInsertions'
                },
                {
                    text: 'Quantity',
                    value: 'quantity',
                    align: 'right'
                },
                {
                    text: 'Price',
                    value: 'price',
                    align: 'right'
                },
                {
                    text: 'Other Price',
                    value: 'adultPrice',
                    align: 'right'
                },
                {
                    text: 'Writing Price',
                    value: 'articleWritingPrice',
                    align: 'right'
                },
                {
                    text: 'Total',
                    value: 'total',
                    align: 'right'
                },
                {
                    text: 'Actions', value: 'actions', sortable: false
                }
            ],
            carts: [],
            currentProduct: {},
            order: {
                name: '',
                email: '',
                phone: '',
                billingType: 'Guest Post',
                date: new Date().toISOString().substr(0, 10),
                paymentMethod: '',
                description: '',
                totalAmount: 0,
                discount: 0,
                amount: 0,
                isSendMail: false
            },
            linkInsertions: [
                {
                    anchorText: '',
                    url: ''
                }
            ],
            product: {
                siteId: null,
                siteUrl: '',
                customEntityName: '',
                liveLink: '',
                quantity: 1,
                price: 0,
                articleWritingPrice: 0,
                adultPrice: 0,
                linkPrice: 0,
                total: 0
            },
            invoiceDueInfo: [],
            clientIcons: [
                {
                    type: 'specialClient',
                    icon: 'mdi-shield-star'
                },
                {
                    type: 'fixClient',
                    icon: 'mdi-shield-account-outline'
                },
                {
                    type: 'agencyClient',
                    icon: 'mdi-alpha-a-circle'
                },
            ],
            isAddBulkLink: false,
            bulkLiveLink: '',
            isBulkCheckedAdultPrice: false,
            clientInfo: null,
            bannedWords: [
                'casino',
                'gambling',
                'slot',
                'betting',
                'poker',
                'baccarat',
                'rummy',
                'jack-pot',
                'jackpot',
                'cbd',
                'vape',
                'marijuana',
            ]
        }
    },
    props: {
        isEditMode: {
            type: Boolean,
            default: function () {
                return false;
            }
        },
        actionHook: {
            type: String,
            default: function () {
                return 'storeInvoice';
            }
        }
    },
    mounted() {
        this.$store.dispatch('loadAllMethods', {status: true});
        this.isOverlay = true;
        if (!this.isEditMode) {
            this.isOverlay = false;
            return;
        }

        const id = this.$route.params.id;
        if (!id) return this.$router.push('/invoices');
        this.$store.dispatch('getByInvoiceId', {id})
            .then((response) => {
                const {
                    id,
                    name,
                    email,
                    phone,
                    totalAmount,
                    invoice_detail: invoiceDetails,
                    discount,
                    amount,
                    billingType,
                    paymentMethod,
                    description
                } = response.data;
                this.ediTableContent = description;
                this.order = {
                    id,
                    name,
                    email,
                    phone,
                    paymentMethod,
                    description,
                    billingType: billingType,
                    date: new Date().toISOString().substr(0, 10),
                    totalAmount,
                    discount,
                    amount,
                    isSendMail: false
                };

                this.carts = invoiceDetails.map((item) => {
                    const {
                        id,
                        price,
                        siteId,
                        invoiceId,
                        quantity,
                        liveLink,
                        site,
                        customEntityName,
                        articleWritingPrice,
                        adultPrice,
                        total,
                        linkPrice
                    } = item;
                    const linkInsertions = this.getLinkInsertions(item)
                    return {
                        id,
                        siteUrl: site && site.site_url ? site.site_url : '',
                        customEntityName,
                        siteId,
                        invoiceId,
                        liveLink,
                        price,
                        quantity,
                        articleWritingPrice,
                        adultPrice,
                        linkPrice,
                        total,
                        linkInsertions
                    }
                })
                this.clientHandler(email);
                this.isOverlay = false;
            })
            .catch((error) => {
                this.isOverlay = false;
                this.$router.push('/invoices');
            })

    },
    computed: {
        ...mapState({
            paymentMethods: function (state) {
                const methods = state.method.allPayMethods;
                const method = methods.find((data) => data.normalizedName === 'paddle');
                const paymentMethod = this.order.paymentMethod;

                if (method) this.order.paymentMethod = paymentMethod ? paymentMethod : method.id;

                return methods;
            }
        }),
        subTotal() {
            let subTotal = Number.parseFloat(
                this.carts.reduce((prev, item) => {
                    return Number.parseFloat(prev + Number.parseFloat(item.total));
                }, 0)
            ).toFixed(2);

            let percentageOfDiscount = this.clientInfo && this.clientInfo.percentageOfDiscount ? Number(this.clientInfo.percentageOfDiscount) : 0;

            if (percentageOfDiscount > 0) {
                this.order.discount = (Number.parseFloat(subTotal) * (percentageOfDiscount / 100)).toFixed(2);
            }

            return subTotal;
        },
        grandTotal() {
            return (this.subTotal - Number.parseFloat(this.order.discount)).toFixed(2)
        },
        getCarts() {
            let cartId = 0;
            return this.carts.map((item) => {
                cartId = cartId + 1;
                return {
                    ...item,
                    cartId
                }
            });
        },
        showClientInnerIcon() {
            if (this.isSpecialClient) {
                return this.getClientIcon('specialClient');
            } else if (this.isFixClient) {
                return this.getClientIcon('fixClient');
            } else if (this.isAgencyClient) {
                return this.getClientIcon('agencyClient');
            } else {
                return '';
            }
        },
    },
    methods: {
        async onSelections(item) {
            this.currentProduct = {...item};
            let {id, siteUrl, resellerPrice, resellerAdultPrice} = item;

            let price = this.clientInfo && this.clientInfo.price && Number(this.clientInfo.price) > 0 ? this.clientInfo.price : resellerPrice;
            let adultPrice = this.clientInfo && this.clientInfo.adultPrice && Number(this.clientInfo.adultPrice) > 0 ? this.clientInfo.price : resellerAdultPrice;
            let _adultPrice = 0;
            let total = price;

            if (this.isCheckedAdultPrice) {
                _adultPrice = Number(adultPrice);
                total = Number(adultPrice) + Number(price)
            }

            this.product = {
                ...this.product,
                siteId: id,
                siteUrl: siteUrl,
                price,
                quantity: 1,
                adultPrice: _adultPrice,
                total
            }

            await this.checkLiveLinks();
        },
        inputPriceHandler() {
            const {price, adultPrice, articleWritingPrice} = this.product;

            this.product.total = (Number(price) + Number(articleWritingPrice) + Number(adultPrice)).toFixed(2);
        },
        handleClearSearchResult() {
            this.resetProductHandler();
        },
        resetProductHandler() {
            this.product = {
                ...this.product,
                site: null,
                siteId: null,
                siteUrl: '',
                price: 0,
                quantity: 1,
                total: 0,
                adultPrice: 0,
                linkPrice: 0,
                articleWritingPrice: 0,
                liveLink: ''
            };
            this.currentProduct = {};
            this.linkInsertions = [
                {
                    anchorText: '',
                    url: ''
                }
            ]
            this.isCheckedAdultPrice = false;
        },
        addToCartHandler() {
            if (!this.$refs.cartFormRef.validate()) return;
            const id = Math.floor((Math.random() * 1000) + 1);

            let cartItem = {
                ...this.product,
                id,
                linkInsertions: _.cloneDeep(this.linkInsertions)
            }

            if (this.isEditMode) cartItem.invoiceId = this.order.id;

            this.carts.push(cartItem);
            this.$refs.cartFormRef.reset();
            this.$nextTick(() => {
                this.resetProductHandler();
            })
        },
        liveLinkHandler(item) {
            this.showLiveLink = true;
            this.currentItem = item;
        },
        closePopupHandler() {
            this.showLiveLink = false;
            this.showLinkInsertionPopup = false;
            this.currentItem = null;
        },
        confirmToDeleteItem(item) {
            this.showItemDeleteConfirm = true;
            this.deleteItem = item;
        },
        getAmountWithSymbol(amount) {
            const _amount = Number.parseFloat(amount).toFixed(2);
            return `$${_amount}`;
        },
        confirmDelete() {
            const id = this.deleteItem.id;
            const index = this.carts.findIndex((item) => item.id === id);

            if (index > -1) {
                this.carts.splice(index, 1);
            }

            this.showItemDeleteConfirm = false;
            this.deleteItem = null;
        },
        onPriceHandler(id, price) {
            const index = this.carts.findIndex((item) => item.id === id);

            if (index > -1) {
                this.carts[index].price = price;
                this.carts[index].total = Number.parseFloat(price) + Number.parseFloat(this.carts[index].adultPrice) + Number.parseFloat(this.carts[index].articleWritingPrice);

                this.carts = [...this.carts];
            }
        },
        onAdultHandler(id, adultPrice) {
            const index = this.carts.findIndex((item) => item.id === id);

            if (index > -1) {
                this.carts[index].adultPrice = adultPrice;
                this.carts[index].total = Number.parseFloat(this.carts[index].price) + Number.parseFloat(adultPrice) + Number.parseFloat(this.carts[index].articleWritingPrice);

                this.carts = [...this.carts];
            }
        },
        onArticleWritingHandler(id, articleWritingPrice) {
            const index = this.carts.findIndex((item) => item.id === id);

            if (index > -1) {
                this.carts[index].articleWritingPrice = articleWritingPrice;
                this.carts[index].total = Number.parseFloat(this.carts[index].price) + Number.parseFloat(this.carts[index].adultPrice) + Number.parseFloat(articleWritingPrice);

                this.carts = [...this.carts];
            }
        },
        onCancelInvoice() {
            this.$refs.editTableBoxDetails.innerHTML = '';
            this.resetForm();
            this.carts = [];
            this.isExists = false;
        },
        resetForm() {
            this.$refs.cartFormRef.reset();
            this.$refs.orderFormRef.reset();
            this.$nextTick(() => {
                this.order = {
                    ...this.order,
                    totalAmount: 0,
                    amount: 0,
                    discount: 0,
                    date: new Date().toISOString().substr(0, 10),
                    billingType: 'Guest Post',
                    description: '',
                    email: '',
                };
                this.$refs.editTableBoxDetails.innerHTML = '';
                this.product = {...this.product, price: 0};
            })
        },
        onConfirmHandler(confirmed = false) {
            if (!this.$refs.orderFormRef.validate()) return;

            if (!confirmed) {
                this.showOrderConfirm = true;
                return;
            }
            this.isOverlay = true;

            this.showOrderConfirm = false;
            let publishableAmount = this.getPublishableAmount();

            this.$store.dispatch(this.actionHook, {
                ...this.order,
                publishableAmount,
                amount: this.subTotal,
                totalAmount: this.grandTotal,
                carts: this.carts
            })
                .then((response) => {
                    if (this.isEditMode) {
                        this.setSnackBar({text: "Invoice Updated Successfully ", type: 'info'});
                        return;
                    }
                    this.setSnackBar({text: "Invoice Added Successfully ", type: 'info'});
                    this.order.refcode = response.data.invoice.refcode;
                    this.showMailTemplate = true;
                    this.isExists = false;
                    this.isOverlay = false;
                })
                .catch((error) => {
                    this.isOverlay = false;
                    this.setSnackBar({text: "Data Validation Error", type: 'error'});
                })

            if (this.isEditMode) this.$router.push({name: 'Invoices', path: '/invoices'});
        },
        getPublishableAmount() {
            return Number.parseFloat(
                this.carts.reduce((prev, item) => {
                    return Number.parseFloat(prev + Number.parseFloat(item.price) + Number.parseFloat(item.adultPrice));
                }, 0)
            ).toFixed(2);
        },
        closeLinkPopupHandler() {
            this.showMailTemplate = false;
            this.resetForm();
            this.carts = [];
        },
        setSnackBar({text, type}) {
            this.$store.commit('SET_SNACKBAR', {text, type});
        },
        async checkLiveLinks() {
            let siteUrl = this.product.siteUrl;
            const linkArr = this.product.liveLink ? this.product.liveLink.split("/") : '';
            let text = _.lowerCase(this.product.liveLink);
            let isBannedWord = _.some(this.bannedWords, (el) => text.includes(el));
            if (isBannedWord) {
                this.setSnackBar({
                    text: `The URL ${this.product.liveLink} has words like: (${this.bannedWords.join(', ')}) must be removed.`,
                    type: 'error'
                });
                return;
            }
            if (linkArr.length < 2) return;

            const linkSite = linkArr[2] ? linkArr[2] : '';

            if (!siteUrl) {
                this.isOverlay = true;
                const site = await this.getBySiteUrl(linkSite);
                if (!site) {
                    this.checkLiveLinkMessageHandler(siteUrl, linkSite);
                    this.isOverlay = false;
                    return;
                }
                siteUrl = site.site_url;
                this.product.siteUrl = siteUrl;
                this.product.site = {
                    ...site,
                    siteUrl,
                    resellerPrice: site.reseller_price,
                    resellerAdultPrice: site.resellerAdultPrice
                };
                this.onSelections(this.product.site);
            }

            if (linkSite !== siteUrl) {
                this.product.liveLink = '';
                this.checkLiveLinkMessageHandler(siteUrl, linkSite)
            }

            this.$nextTick(() => {
                this.product = {...this.product};
                this.isOverlay = false;
            });
        },
        checkLiveLinkMessageHandler(siteUrl, linkSite) {
            this.setSnackBar({
                text: `You are selected this ${siteUrl} and your live link from ${linkSite} does not matched each other. Please check your live link`,
                type: 'error'
            })
        },
        async getBySiteUrl(url) {
            return Sites
                .getByOne({siteUrl: url})
                .then((response) => response.data);
        },
        onLinkUpdateHandler(item) {
            const {id, liveLink} = item;
            const index = this.carts.findIndex((data) => data.id === id);

            if (index > -1) {
                this.carts[index].liveLink = liveLink;
            }

            this.closePopupHandler();
        },
        linkInsertionRowHandler() {
            if (this.linkInsertions.length >= 10) return;
            this.linkInsertions.push({anchorText: '', url: ''});
        },
        linkInsertionRowRemoveHandler(index) {
            this.linkInsertions.splice(index, 1)
        },
        onCheckboxAdultHandler() {
            let adultPrice = this.clientInfo && this.clientInfo.adultPrice && Number(this.clientInfo.adultPrice) > 0 ? Number(this.clientInfo.adultPrice) : Number(this.currentProduct.resellerAdultPrice);

            if (this.isCheckedAdultPrice) {
                this.product.adultPrice = adultPrice;
                this.product.total = Number(this.product.total) + adultPrice;
            } else {
                this.product.adultPrice = 0;
                this.product.total = Number(this.product.total) - adultPrice;
            }
        },
        linkInsertionPopupHandler(item) {
            this.showLinkInsertionPopup = true;
            this.currentItem = item;
        },
        updateLinkInsertionHandler(item) {
            const index = this.carts.findIndex(data => data.id === item.productId);
            if (index > -1) {
                this.carts[index].linkInsertions = item.linkInsertions;
            }
            this.closePopupHandler();
        },
        getLinkInsertions(item) {
            const {
                anchorText1,
                url1,
                anchorText2,
                url2,
                anchorText3,
                url3,
                anchorText4,
                url4,
                anchorText5,
                url5,
                anchorText6,
                url6,
                anchorText7,
                url7,
                anchorText8,
                url8,
                anchorText9,
                url9,
                anchorText10,
                url10
            } = item;

            let arr = []

            if (anchorText1) {
                arr.push({anchorText: anchorText1, url: url1})
            }

            if (anchorText2) {
                arr.push({anchorText: anchorText2, url: url2})
            }

            if (anchorText3) {
                arr.push({anchorText: anchorText3, url: url3})
            }

            if (anchorText4) {
                arr.push({anchorText: anchorText4, url: url4})
            }

            if (anchorText5) {
                arr.push({anchorText: anchorText5, url: url5})
            }

            if (anchorText6) {
                arr.push({anchorText: anchorText6, url: url6})
            }

            if (anchorText7) {
                arr.push({anchorText: anchorText7, url: url7})
            }

            if (anchorText8) {
                arr.push({anchorText: anchorText8, url: url8})
            }

            if (anchorText9) {
                arr.push({anchorText: anchorText9, url: url9})
            }

            if (anchorText10) {
                arr.push({anchorText: anchorText10, url: url10})
            }

            return arr;
        },
        handleEditableInput(e) {
            this.order.description = e.target.innerHTML;
        },
        async onSelectionsEmailHandler(selection) {
            this.order.email = selection.email;
            await this.clientHandler(selection.email);
        },
        handleClearSearchResultEmail() {
            this.isSpecialClient = false;
            this.isAgencyClient = false;
            this.order.email = '';
        },
        async clientHandler(email) {
            this.clientInfo = null;
            this.invoiceDueInfo = [];
            if (!email) return;
            this.isOverlay = true;

            try {
                const {data: {dueData, clientInfo, invoiceInfo}} = await Clients.getOne({email});
                this.invoiceDueInfo = dueData;
                if (invoiceInfo) {
                    let {name, phone, description} = invoiceInfo;
                    this.order.name = name;
                    this.order.phone = phone;
                    this.order.description = description;
                    this.ediTableContent = description;
                }

                if (!clientInfo) {
                    this.isOverlay = false;
                    return;
                }

                if (clientInfo.isBlocked) {
                   // const msg = `This email: [${clientInfo.email}] is currently blocked. Invoice creation is not allowed at this time.`
                    this.order.email = null;
                    this.showBlockedClient = true;
                    this.blockedClientInfo = clientInfo;
                   // this.setSnackBar({text: msg, type: "error"})
                    this.isOverlay = false;
                    return;
                }

                this.clientInfo = clientInfo;

                /*let price = this.getFixClientPrice();

                if(this.product.siteId){
                    this.product.price = price;
                    this.inputPriceHandler();
                }

                if(this.carts.length > 0) {
                    this.carts =  this.carts.map((item) => {
                        let articleWritingPrice = this.product.articleWritingPrice;
                        return {
                            ...item,
                            price,
                            linkPrice: 0,
                            adultPrice: 0,
                            total: (Number(price) + Number(articleWritingPrice)).toFixed(2)
                        }
                    })
                }*/

                this.isOverlay = false;
            } catch (error) {
                this.isOverlay = false;
            }
        },
        getFixClientPrice() {
            const {price, linkPrice, adultPrice} = this.clientInfo;
            const billingType = this.order.billingType;

            if (this.isCheckedAdultPrice) {
                return Number.parseFloat(adultPrice);
            } else if (billingType === 'Link Insert' || billingType === 'Home Page Link Insertion on') {
                this.product.articleWritingPrice = 0;
                return Number.parseFloat(linkPrice);
            } else {
                return Number.parseFloat(price);
            }
        },
        getClientIcon(type) {
            let client = this.clientIcons.find((item) => item.type === type);
            if (client) {
                return client.icon;
            }

            return '';
        },
        fixClientBillingTypeHandler() {
            if (!this.fixClient || !this.product.siteId) return;

            let price = this.getFixClientPrice();

            /*Object.assign(this.product, {
                ...this.product,
                price,
                linkPrice: 0,
                adultPrice: 0,
                total: Number.parseFloat(this.product.articleWritingPrice) + price
            })*/
        },
        async bulkLiveLinkHandler(event) {
            if (!event) return;
            this.isOverlay = true;
            let links = event.split("\n");

            let sites = links.map((item) => {
                let siteLink = this.getSiteUrl(item);
                if (siteLink) {
                    return siteLink
                }
            })

            sites = _.uniq(sites);
            const {data} = await Sites.getBulkSite({sites: sites});
            links.forEach((item) => {
                const id = Math.floor((Math.random() * 1000) + 1);
                let siteLink = this.getSiteUrl(item);
                let site = data.find((data) => data.site_url === siteLink);
                if (site) {
                    let price = site.reseller_price;
                    let adultPrice = site.resellerAdultPrice;
                    let total = price;
                    let product = {
                        siteId: site.id,
                        siteUrl: site.site_url,
                        customEntityName: '',
                        liveLink: item,
                        quantity: 1,
                        price: price,
                        articleWritingPrice: 0,
                        linkPrice: 0,
                        adultPrice: 0,
                        total: total
                    };
                    if (this.isBulkCheckedAdultPrice) {
                        product.adultPrice = adultPrice;
                        product.total = (Number(price) + Number(adultPrice)).toFixed(2);
                    }


                    if (this.order.id) {
                        this.carts.push({
                            ...product,
                            id,
                            invoiceId: this.order.id,
                            linkInsertions: _.cloneDeep(this.linkInsertions)
                        });
                    } else {
                        this.carts.push({...product, id, linkInsertions: _.cloneDeep(this.linkInsertions)});
                    }
                }
            });

            this.bulkLiveLink = ''
            this.isBulkCheckedAdultPrice = false;
            this.isOverlay = false;
        },
        getSiteUrl(item) {
            const linkArr = item.split("/");
            if (linkArr.length > 2) {
                return linkArr[2] ? linkArr[2] : '';
            }
            return '';
        }
    }
}